import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';

import {BDCheckboxFilter, ModalDynamicService} from '@brother-apps/brother-dealerapp-shared-lib';
import {
    DeleteAttentionModalComponent
} from '../../components/projects-table-components/project_table/delete-attention-modal/delete-attention-modal.component';
import {EnumUtils} from '../../utils/enum.utils';
import {IProjectService} from '../../services/project.service.interface';
import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {
    ProjectHistoryTableModalComponent
} from '../../components/projects-table-components/project_table/project-history-table-modal/project-history-table-modal.component';
import {ProjectsEditModalComponent} from '../../components/edit-modal/edit-modal.component';
import {ProjectsListItemModel, ProjectsListItemPagingModel} from '../../models/projects-list-item.model';
import {EditModalService} from '../../services/edit-modal.service';
import {debounceTime, throttle} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {ProjectsApprovalListItemModel} from '../../models/projects-approval-list-item.model';
import {MyProjectTabIdEnum} from '../../enums/my-project-tab-id.enum';
import {MyApprovalStatusEnum} from '../../enums/my-approval-status.enum';
import {MyCsvColumnsEnum} from '../../enums/my-csv-columns.enum';
import {DatePipe} from '@angular/common';
import {MyProjectStatusBarTranslateEnum, MyProjectStatusDetailsCSVTranslateEnum} from '../../enums/my-project-status-bar-translate.enum';
import {ProjectListOrderByModel, ProjectListOrderByParamsModel} from '../../models/project-list-order-by.model';
import {ProjectListOrderByColumnEnum} from '../../enums/project-list-order-by-column.enum';
import {ProjectListOrderDirectionEnum} from '../../enums/project-list-order-direction.enum';
import {
    ModalDataProcessingAgreementComponent
} from '../../../data-processing-agreement/components/modal-data-processing-agreement/modal-data-processing-agreement.component';
import {ProjectListItemFilterModel} from '../../models/project-list-item-filter.model';
import {ProjectsFilterModalComponent} from '../../components/projects-filter-modal/projects-filter-modal.component';
import {ProjectStatusEnum} from '../../enums/project-status.enum';
import {LocalStorageService} from '../../../../core/services/local-storage.service';
import {ModalDynamicV3Service} from '../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-projects-root',
    templateUrl: './root.page.html',
    styleUrls: ['./root.page.scss']
})
export class ProjectsRootComponent implements OnInit, AfterViewInit, OnDestroy {
    public projectsLoading: boolean;

    public projects: ProjectsListItemModel[];
    public showPaging = true;
    public projectsPaging: ProjectsListItemPagingModel;

    public projectListFilterParams = {} as ProjectListItemFilterModel;

    public originalProjects: ProjectsListItemModel[];
    public projectApprovals_toBeApproved: ProjectsApprovalListItemModel[];
    public projectApprovals_Processed: ProjectsApprovalListItemModel[];

    // tslint:disable:max-line-length
    public closedProjectsFilterChoices = [
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.REJECTED), ProjectStatusEnum.REJECTED.toString()),
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.PROJECT_WON), ProjectStatusEnum.PROJECT_WON.toString()),
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.PROJECT_LOST), ProjectStatusEnum.PROJECT_LOST.toString()),
    ];

    public openedProjectsFilterChoices = [
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.DRAFT), ProjectStatusEnum.DRAFT.toString()),
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.REQUEST), ProjectStatusEnum.REQUEST.toString()),
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.IN_PROCESS), ProjectStatusEnum.IN_PROCESS.toString()),
        new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.QUOTE_SENT), ProjectStatusEnum.QUOTE_SENT.toString()),

    ];

    // public allProjectsFilterChoices = [
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.DRAFT), ProjectStatusEnum.DRAFT.toString()),
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.REQUEST), ProjectStatusEnum.REQUEST.toString()),
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.IN_PROCESS), ProjectStatusEnum.IN_PROCESS.toString()),
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.QUOTE_SENT), ProjectStatusEnum.QUOTE_SENT.toString()),
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.REJECTED), ProjectStatusEnum.REJECTED.toString()),
    //     new BDCheckboxFilter(EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.PROJECT_WON), ProjectStatusEnum.PROJECT_WON.toString()),
    //
    // ];

    private scrollEvent: EventEmitter<void> = new EventEmitter();
    private scrollStartSub: Subscription;

    public myProjectTableIdEnum = MyProjectTabIdEnum;

    public pageNameExtension = '';
    public isPriceApprovalMode: boolean;
    private activeTabId: MyProjectTabIdEnum;
    public filteredProjectItemsCount = -1;
    public pageSize = 10;
    public page = 1;


    public pageOfItems: Array<any>;
    public pages: number[] = [];
    public pagesBeApproved: number[] = [];
    public pagesProcessed: number[] = [];
    public startIndex: number;
    public endIndex: number;
    public btnBackActive = false;
    public btnForwardActive = false;

    public orderByParams = new ProjectListOrderByModel();
    public orderByParamsToBeApproved = new ProjectListOrderByModel();
    public orderByParamsProcessed = new ProjectListOrderByModel();
    public isAgreementConfirmed = true;


    public constructor(
        private projectService: IProjectService,
        private modalDynamicService: ModalDynamicService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private modalVisibilityService: ModalVisibilityService,
        private editModalService: EditModalService,
        private localStorageService: LocalStorageService
    ) {
    }

    // public closedProjectsTableProjectFilterFn: Function = (project) => {
    //     return +ProjectStatusEnum[project.status] >= ProjectStatusEnum.REJECTED && +ProjectStatusEnum[project.status] !== ProjectStatusEnum.QUOTE_SENT_MANUALLY;
    // };
    //
    // public openedProjectsTableProjectFilterFn: Function = (project) => {
    //     return +ProjectStatusEnum[project.status] < ProjectStatusEnum.REJECTED || +ProjectStatusEnum[project.status] === ProjectStatusEnum.QUOTE_SENT_MANUALLY;
    // };
    //
    // public priceApprovalReadyTableProjectFilterFn: Function = (project) => {
    //     // by new spec the filtering is useless for this case
    //     return true;
    // };
    //
    // public priceApprovalProcessedTableProjectFilterFn: Function = (project) => {
    //     // by new spec the filtering is useless for this case
    //     return true;
    // };

    public async ngOnInit(): Promise<void> {


        this.isPriceApprovalMode = false;


        const orderByColumn = ProjectListOrderByColumnEnum.ROLLOUT_START;
        const orderByDirection = ProjectListOrderDirectionEnum.ASC;

        const orderPriceApprovalByColumn = ProjectListOrderByColumnEnum.QUOTE_CLOSING_DATE;
        const orderPriceApprovalByDirection = ProjectListOrderDirectionEnum.ASC;

        const orderPriceApprovalByParam = new ProjectListOrderByParamsModel();
        orderPriceApprovalByParam.column = orderPriceApprovalByColumn;
        orderPriceApprovalByParam.direction = orderPriceApprovalByDirection;
        this.orderByParamsToBeApproved.orderBy = [];
        this.orderByParamsToBeApproved.orderBy.push(orderPriceApprovalByParam);
        this.orderByParamsProcessed.orderBy = [];
        this.orderByParamsProcessed.orderBy.push(orderPriceApprovalByParam);


        const orderByParam = new ProjectListOrderByParamsModel();
        orderByParam.column = orderByColumn;
        orderByParam.direction = orderByDirection;
        this.orderByParams.orderBy = [];
        this.orderByParams.orderBy.push(orderByParam);

        // tslint:disable-next-line:max-line-length
        try {
            this.projectListFilterParams = (ProjectListItemFilterModel.fromJson(
                    JSON.parse(this.localStorageService.getProjectFilter())) ||
                {}) as ProjectListItemFilterModel;
        } catch (e) {
            this.projectListFilterParams = {};
        }

        this.activeTabId = this.isPriceApprovalMode ? MyProjectTabIdEnum.READY_TO_APPROVE : MyProjectTabIdEnum.OPENED;
        await this.initProjects();

        this.scrollStartSub = this.scrollEvent.pipe(
            // to emit new scrollStart event, the scroll events must be paused at least for 300ms
            throttle(() => this.scrollEvent.pipe(debounceTime(300)))
        ).subscribe(x => this.modalVisibilityService.announceCloseProjectsListPageModalsRequest());

    }


    public orderByProjectList(orderBy: ProjectListOrderByModel) {


        this.orderByParams = orderBy;
        this.initProjects();


    }


    public ngAfterViewInit(): void {
        window.addEventListener('scroll', this.onWindowScroll);
    }

    private getPageCount(): number {
        let totalPage = 0;

        if (this.projectsPaging !== undefined && this.projectsPaging.pagination.totalCount > 0 && this.pageSize > 0) {
            const pageCount = this.projectsPaging.pagination.totalCount / this.pageSize;
            const roundedPageCount = Math.floor(pageCount);
            totalPage = roundedPageCount < pageCount ? roundedPageCount + 1 : roundedPageCount;
        }

        return totalPage;
    }

    private getArrayOfPage(pageCount: number): number[] {
        const pageArray: number[] = [];

        if (pageCount > 0) {
            for (let i = 1; i <= pageCount; i++) {
                pageArray.push(i);
            }
        }
        return pageArray;
    }


    public setRecordsPerPage(records: number) {


        this.pageSize = records;
        this.page = 1;

        this.initProjects();
        this.pages = this.getArrayOfPage(this.getPageCount());


    }


    onClickPage(pageNumber: number, pages: any) {
        console.log('onClickPage', pageNumber);

        this.page = pageNumber;
        this.initProjects();
    }

    private updatePaginatorButtonsState(pageNumber: number, pages: any) {

        this.btnBackActive = false;
        this.btnForwardActive = false;

        if (+pages.length < 2) {
            return;
        }

        if (pageNumber > 1 && +pages.length > 1) {
            this.btnBackActive = true;
        }

        if (pageNumber < +pages.length) {
            this.btnForwardActive = true;
        }
    }


    public openFeedbackLink() {
        // tslint:disable-next-line:max-line-length
        const url = 'https://forms.office.com/Pages/ResponsePage.aspx?id=q1i1m6U8uEG39hJbp9imcbbGxQ6Z7SRPjoCynpM6SBtUQkk4UTJEQ1IwQzEzOEpaMDAyRjdHRjUxUC4u';
        window.open(url, '_blank');
    }


    private async loadProjectsForCurrentTable() {

        const projectListFilterParamsForActiveTable = this.getFilterParamsForActiveTable(this.projectListFilterParams);
        switch (this.activeTabId) {
            case MyProjectTabIdEnum.OPENED:
            case MyProjectTabIdEnum.CLOSED:
                this.projectsPaging = await this.projectService.getProjectsPaging(this.pageSize, this.page, this.orderByParams, projectListFilterParamsForActiveTable);
                this.projects = this.projectsPaging.data as ProjectsListItemModel[];
                break;
            case MyProjectTabIdEnum.READY_TO_APPROVE:
                this.projectApprovals_toBeApproved = await this.projectService.getProjectPriceApprovals(MyApprovalStatusEnum.TO_BE_APPROVED);
                break;
            case MyProjectTabIdEnum.APPROVAL_DONE:
                this.projectApprovals_Processed = await this.projectService.getProjectPriceApprovals(MyApprovalStatusEnum.APPROVED_AND_REJECTED);
                break;
        }
    }

    private finishPageSettings() {
        this.projectsLoading = false;
        const pageCount = this.getPageCount();
        this.pages = this.getArrayOfPage(pageCount);
        this.updatePaginatorButtonsState(this.page, this.pages);
    }

    private async handleAgreementResult(val: { dialogConfirmed: boolean }) {

        try {
            if (val.dialogConfirmed) {
                await this.loadProjectsForCurrentTable();
                this.isAgreementConfirmed = true;
            } else {
                this.isAgreementConfirmed = false;
            }
        } finally {
            this.finishPageSettings();
        }


    }

    public async initProjects(): Promise<void> {
        console.log('initProjects, loading projects for table', this.activeTabId);

        this.projectsLoading = true;

        this.isAgreementConfirmed = true;

        try {
            // hack to make dynamic modal component opening faster
            this.modalDynamicService.preloadDynamicModalComponent(ProjectHistoryTableModalComponent);
            if (!this.isPriceApprovalMode) {
                this.modalDynamicService.preloadDynamicModalComponent(DeleteAttentionModalComponent);
                this.modalDynamicService.preloadDynamicModalComponent(ProjectsEditModalComponent);
            }
        } catch {
        }

        try {
            await this.loadProjectsForCurrentTable();
            this.finishPageSettings();
        } catch (error) {
            console.error(error);

            // if (error.status === 401 && error?.error?.error?.toString().toLowerCase() === 'unauthorized') {
            //     const dialogRef = this.modalDynamicV3Service.open(ModalDataProcessingAgreementComponent);
            //     const dialogSub = dialogRef.subscribe(async (val: any) => {
            //         // console.log('val', val);
            //         await this.handleAgreementResult(val);
            //         dialogSub.unsubscribe();
            //     });
            //
            // } else {
            //     console.warn('unexpected error occurred, data agreement status is unknown - expected error number:401, expected message: unauthorized, current error : ', error);
            //     this.finishPageSettings();
            // }
        }
    }


    public onNewProjectBtnClicked() {

        if (!this.editModalService.isDialogOpened) {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
            const dialogRef: IModalDialogV3 = this.modalDynamicV3Service
                .open(ProjectsEditModalComponent, {
                    model: {projectId: null}
                });
            dialogRef.subscribe(async (val) => {
                console.log('handleEditModalResult called from root page');
                await this.editModalService.handleEditModalResult(val, dialogRef);
                // this.projects = await this.projectService.getProjects();
                // this.projectsPaging = await this.projectService.getProjectsPaging(this.pageSize, this.page, this.orderByParams, this.projectListStatusFilter);
                // this.projects = this.projectsPaging.data as ProjectsListItemModel[];
                this.initProjects();
            });
        }

    }


    public async onTabBtnClicked(tabId: MyProjectTabIdEnum) {
        this.activeTabId = tabId;
        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        const defaultPageSize = 10;
        const defaultPage = 1;

        this.pageSize = defaultPageSize;
        this.page = defaultPage;

        this.projectListFilterParams.status = [];

        await this.initProjects();
    }

    public isTabActive(tabId: MyProjectTabIdEnum) {
        return tabId === this.activeTabId;
    }

    public isInternalUser() {
        return false;
    }


    public onCsvExportBtnClicked() {
        // console.log('onCsvExportBtnClicked', this.projects);
        let csvContent = '';
        const columnDivider = ';';
        const rowDivider = '\n';

        Object.keys(MyCsvColumnsEnum).forEach(key => {

            csvContent += MyCsvColumnsEnum[key] + columnDivider;
            // console.log(key) // returns the keys in an object
            // console.log(MyCsvColumnsEnum[key])  // returns the appropriate value
        });

        csvContent = csvContent.slice(0, csvContent.length - 1) + rowDivider;

        this.projects.forEach(project => {
            Object.keys(MyCsvColumnsEnum).forEach(key => {

                switch (MyCsvColumnsEnum[key]) {

                    case MyCsvColumnsEnum.lastUpdateBy:
                        const sValue = project[key];
                        csvContent += sValue ? sValue : '';
                        break;
                    case MyCsvColumnsEnum.rolloutStart:
                    case MyCsvColumnsEnum.rolloutEnd:
                        const dValue = project[key];
                        csvContent += dValue ? new DatePipe('de_DE').transform(dValue, 'dd.MM.yyyy') : '';
                        break;
                    case MyCsvColumnsEnum.status:
                        csvContent += MyProjectStatusBarTranslateEnum [project[key]];
                        break;
                    case MyCsvColumnsEnum.priceApprovalStatus:
                    case MyCsvColumnsEnum.statusDetails:
                        csvContent += MyProjectStatusDetailsCSVTranslateEnum [project[key]];
                        break;
                    case MyCsvColumnsEnum.priceApprovalComment:
                        let tValue = project[key];
                        if (tValue) {
                            tValue = tValue.replace(/"/g, '""');
                            csvContent += '"' + tValue + '"';
                        }

                        break;
                    default:
                        csvContent += project[key];
                }
                csvContent += columnDivider;

            });
            csvContent = csvContent.slice(0, csvContent.length - 1) + rowDivider;
        });


        csvContent = csvContent.replace(/undefined,/g, '');
        csvContent = csvContent.replace(/null,/g, '');


        const blob = new Blob([csvContent], {
            type: 'text/plain'
        });

        const data = window.URL.createObjectURL(blob);
        //
        const link = document.createElement('a');
        link.href = data;
        link.download = 'projektliste.csv';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
        return;

    }

    private onWindowScroll = (): void => {
        this.scrollEvent.next();
        // tslint:disable-next-line
    };

    public getPageNameExtension(): string {
        return '';
    }


    public async onProjectChangedNotification() {
        this.initProjects();
    }

    public async onProjectApprovalsChangedNotification() {
        this.initProjects();
    }

    public ngOnDestroy(): void {
        window.removeEventListener('scroll', this.onWindowScroll);
        if (this.scrollStartSub) {
            this.scrollStartSub.unsubscribe();
        }
    }

    public onStatusFilterValuesChanged(activeStatus: string[]) {
        // console.log('onStatusFilterValuesChanged');
        this.projectListFilterParams.status = activeStatus;
        this.page = 1;
        this.initProjects();
    }

    private getFilterParamsForActiveTable(projectListFilterParams: ProjectListItemFilterModel): ProjectListItemFilterModel {

        // console.log('getFilterParamsForActiveTable',MyProjectTabIdEnum[this.activeTabId], this.activeTabId);
        if (projectListFilterParams?.status?.length > 0) {
            return projectListFilterParams;
        }

        const newFilters = {...projectListFilterParams};
        const statusFilter: string[] = [];

        switch (this.activeTabId) {
            case MyProjectTabIdEnum.OPENED:
                Object.keys(ProjectStatusEnum).forEach(statusName => {
                    if (+ProjectStatusEnum[statusName] < ProjectStatusEnum.REJECTED || +ProjectStatusEnum[statusName] === ProjectStatusEnum.QUOTE_SENT_MANUALLY) {
                        statusFilter.push(statusName);
                    }
                });
                break;
            case MyProjectTabIdEnum.CLOSED:
                Object.keys(ProjectStatusEnum).forEach(statusName => {
                    if (+ProjectStatusEnum[statusName] >= ProjectStatusEnum.REJECTED && +ProjectStatusEnum[statusName] !== ProjectStatusEnum.QUOTE_SENT_MANUALLY) {
                        statusFilter.push(statusName);
                    }
                });
                break;
            default:
            // do something
        }
        newFilters.status = statusFilter;
        return newFilters;
    }

    public async onRepeatAgreementLinkClicked() {
        await this.initProjects();
    }

    /** returns true if some property has some value, only status property is ignored **/
    public hasTopFilterValues(): boolean {
        return this.projectListFilterParams && !!(Object.keys(this.projectListFilterParams).some(key => key !== 'status' && this.projectListFilterParams[key]));
    }

    public async resetProjectFilter() {
        this.localStorageService.removeProjectFilter();
        this.clearTopFilterParams();
        await this.initProjects();
    }

    /**
     * given params for top filter button will be cleared form this.projectListFilterParams (all but not status)
     * @param filterParams
     */
    private clearTopFilterParams() {
        const oldProjectListFilterParams = this.projectListFilterParams;
        this.projectListFilterParams = new ProjectListItemFilterModel();
        if (oldProjectListFilterParams && oldProjectListFilterParams.status) {
            this.projectListFilterParams.status = oldProjectListFilterParams.status;
        }
    }

    public openProjectsFilterModal() {


        if (!this.editModalService.isDialogOpened) {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
            const dialogRef: IModalDialogV3 = this.modalDynamicV3Service
                .open(ProjectsFilterModalComponent, {
                    model: {projects: null}
                });
            dialogRef.subscribe(async (val) => {
                this.setTopFilterParams(ProjectListItemFilterModel.fromJson(JSON.parse(this.localStorageService.getProjectFilter())) as ProjectListItemFilterModel);
                console.log('process ProjectsFilterModal closed,  this.projectListFilterParams', this.projectListFilterParams);
                this.page = 1;
                await this.initProjects();
            });
        }

    }

    /**
     * given params for top filter button will be saved to this.projectListFilterParams (all but not status filed)
     * @param filterParams
     */
    private setTopFilterParams(filterParams: ProjectListItemFilterModel) {
        const oldProjectListFilterParams = this.projectListFilterParams;
        this.projectListFilterParams = filterParams;
        if (oldProjectListFilterParams && oldProjectListFilterParams.status) {
            this.projectListFilterParams.status = oldProjectListFilterParams.status;
        }
    }
}
